import * as React from 'react'
import EditVendorContactDialog from 'vendors/components/vendorContact/dialogs/EditVendorContactDialog'
import GeneralContactForm from 'vendors/components/vendorContact/dialogs/GeneralContactForm'
import { useGeneralContactForm } from 'vendors/components/vendorContact/useGeneralContactForm'
import { useGetGeneralContact, useUpdateGeneralContact } from 'vendors/queries/useVendorQuery'
import { useSnackbar } from 'snackbar/SnackbarContext'
import { useTranslation } from 'react-i18next'

type EditVendorGeneralContactDialogProps = {
  onClose: () => void
  vendorId: string
  generalContactId: string
}

const EditVendorGeneralContactDialog: React.FC<EditVendorGeneralContactDialogProps> = ({
  onClose,
  vendorId,
  generalContactId
}) => {
  const { data: contact, isLoading } = useGetGeneralContact(vendorId, generalContactId)
  const { t } = useTranslation()

  const {
    generalContactFormProps,
    generalEmail,
    generalReceiveRequestForProposals,
    initForm: initGeneralForm
  } = useGeneralContactForm()

  const { showSnackbar } = useSnackbar()

  const {
    isPending: isEditingGeneralContact,
    isSuccess: isEditingGeneralContactSuccess,
    mutate: editGeneralContact
  } = useUpdateGeneralContact(vendorId, generalContactId)

  const isDisabled = React.useMemo(() => generalEmail === '', [generalEmail])

  React.useEffect(() => {
    if (contact && !isLoading) {
      initGeneralForm(contact.email, contact.receiveRequestForProposals)
    }
  }, [initGeneralForm, contact, isLoading])

  React.useEffect(() => {
    if (isEditingGeneralContactSuccess) {
      showSnackbar(t('contact-edited-successfully'))
      onClose()
    }
  }, [isEditingGeneralContactSuccess, onClose, showSnackbar, t])

  const handleEditUserContact = () => {
    const payload = {
      email: generalEmail.toLowerCase(),
      receiveRequestForProposals: generalReceiveRequestForProposals
    }
    editGeneralContact(payload)
  }

  return (
    <EditVendorContactDialog
      isInitingData={isLoading}
      onClose={onClose}
      isDisabled={isDisabled}
      onClick={handleEditUserContact}
      isLoading={isEditingGeneralContact}
    >
      <GeneralContactForm isEdit={true} {...generalContactFormProps} />
    </EditVendorContactDialog>
  )
}

export default EditVendorGeneralContactDialog
